import Popup from 'reactjs-popup'
import React from 'react'
import { HeaderDropdown, HeaderDropdownItem } from './HeaderDropdown'

export default function ProjectDropdown({ trigger, position, contentStyle }) {
	return (
		<Popup
			trigger={trigger}
			position={position}
			on='click'
			closeOnDocumentClick
			mouseLeaveDelay={300}
			mouseEnterDelay={0}
			contentStyle={contentStyle}
			arrow={false}
		>
			<HeaderDropdown>
				<HeaderDropdownItem href='/documents/Das Projekt__Text-6.5_(2026-Jul).pdf'>
					Projektbeschreibung
				</HeaderDropdownItem>
				<HeaderDropdownItem href='/documents/Nutzen des Projekts-3_(2025-12-15)_MS_XXX.pdf'>
					Projektnutzen
				</HeaderDropdownItem>
				<HeaderDropdownItem href='/documents/Hochrechnung-2_(Anzahl Gemälde im Ldk)_MS_XXX.pdf'>
					Eine Hochrechnung
				</HeaderDropdownItem>
				{/*<HeaderDropdownItem>Einwilligungsformular</HeaderDropdownItem>
        <HeaderDropdownItem>Navigationsanleitung</HeaderDropdownItem>
        <HeaderDropdownItem href="">Aktuelles</HeaderDropdownItem>
        */}
			</HeaderDropdown>
		</Popup>
	)
}
